import { LayoutHeader, LayoutHeaderProps, ComponentTypes, Container, PanelProps, Button, Panel, Component } from "@mcleod/components";
import { CollapsingHeader } from "./CollapsingHeader";
import { CollapseController } from "./CollapseController";
import { AppHeaderActions, AppHeaderActionPanels } from "./AppHeaderActions";

export class AppLayoutHeader extends LayoutHeader implements CollapsingHeader, AppHeaderActionPanels {
    private _initialHeight: number;
    private _isTitleCollapsed: boolean;
    private _appHeaderActions: AppHeaderActions;

    constructor(props?: Partial<LayoutHeaderProps>) {
        super(props);
        if (this._designer == null) {
            this.setProps({ marginTop: 16, marginRight: 0, marginLeft: 0, marginBottom: 0, padding: 0, paddingTop: 0, paddingBottom: 0 });
        }
    }

    protected override get initComponents(): Component[] {
        return [this.panelTitle, this.addlPanelBottom];
    }

    public override get panelTitle(): Panel {
        const panel = super.panelTitle;
        panel.setProps({ fillRow: true, rowBreak: true, paddingTop: 12, paddingBottom: 12 });
        return panel;
    }

    public get defaultProps(): Partial<PanelProps> {
        if (this._designer == null)
            return { fillRow: true, marginBottom: 0, padding: 0 };
        else
            return super.defaultProps;
    }

    override get parent(): Container {
        return super.parent;
    }

    override set parent(value: Container) {
        super.parent = value;
        if (this._designer == null) {
            CollapseController.pushCollapsingHeader(this);
        }
    }

    get isTitleCollapsed(): boolean {
        return this._isTitleCollapsed ?? false;
    }

    set isTitleCollapsed(value: boolean) {
        this._isTitleCollapsed = value;
    }

    get initialHeight(): number {
        return this._initialHeight;
    }

    set initialHeight(value: number) {
        this._initialHeight = value;
    }

    get rhsActionButton(): Button | null {
        if (this.appHeaderActions.hasActions)
            return this.appHeaderActions.contextButton;
        return null;
    }

    private get appHeaderActions(): AppHeaderActions {
        if (this._appHeaderActions == null) {
            this._appHeaderActions = new AppHeaderActions(this);
        }
        return this._appHeaderActions;
    }

    public addAppAction(button: Button): void {
        this.appHeaderActions.addAppAction(button);
    }
}

ComponentTypes.registerAppComponentType("layoutheader", {
    constructor: AppLayoutHeader.prototype.constructor
});
